import React from 'react'
import { Divider, Link, List, ListItem, ListItemAvatar, ListItemText, TextField, Typography } from "@mui/material";
import { TCategoryType } from "../../../../shared/Constants";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

interface ICartTileProps {
  index: number;
  name: string;
  price: string;
  currency: string;
  icon: string;
  count: number;
  type: TCategoryType;
  itemChangeHandler: (event: any, item: any) => void;
  onIncrement: (index: number) => void;
  onDecrement: (index: number) => void;
  filteredClothesList: any[];
  handleBoxSizeChange: (event: any, item: any) => void;
}

export const CartList: React.FC<ICartTileProps> = ({
    itemChangeHandler,
    onIncrement,
    onDecrement,
    filteredClothesList,
    handleBoxSizeChange
  }) => {
  return (
    <List sx={{ bgcolor: 'background.paper'}} >
    {filteredClothesList?.length > 0 ? (filteredClothesList?.map((item: any, index: number) => {
      const defaultQty = item?.pricingType === 2 && item?.quantity === 0 ? 1 : (item?.quantity ?? 0);
      let defaultSize = "0.0"; 
      if (item?.itemSize !== undefined && item?.itemSize !== null && item?.itemSize !== "") {
        const parsedSize = parseFloat(item.itemSize);
        if (!isNaN(parsedSize)) {
          defaultSize = parsedSize.toFixed(1);
        }
      }

      return (
        <React.Fragment key={`laundry_${index}_${item.id || index}`}>
          <ListItem secondaryAction={
            <div style={{display: "flex", flexDirection: "row", justifyContent: "end", alignItems: "center"}}>
              {item?.pricingType === 2 && (
                <TextField
                  id={`sizeInput${index}`}
                  variant="standard"
                  type="number"
                  sx={{ width: '60px', marginRight: '10px' }}
                  value={defaultSize}
                  inputProps={{
                    step: '0.1', // Allows native decimal increment/decrement arrows
                    style: { textAlign: 'center' },
                  }}
                  onChange={(event) => handleBoxSizeChange(event, item)}
                />
              )}
              <Link style={{marginLeft: "10px"}}
                component="button"
                title="remove item"
                onClick={(event) => {
                  event?.preventDefault();
                  event?.stopPropagation();
                  onDecrement(item.id);
                }}
              >
                <RemoveCircleOutlineIcon color="primary" />
              </Link>
              <TextField
                id="editInput"
                variant="standard"
                type="number"
                sx={{ width: '50px' }}
                value={defaultQty}
                inputProps={{
                  style: { textAlign: 'center' },
                }}
                onChange={(event: any) => itemChangeHandler(event, item)}
              />
              <Link
                component="button"
                title="add item"
                onClick={(event) => {
                  event?.preventDefault();
                  event?.stopPropagation();
                  onIncrement(item.id);
                }}
              >
                <AddCircleOutlineIcon color="primary" />
              </Link>
            </div>
          }>
            <ListItemAvatar>
              <img
                src={item?.icon}
                width={'60px'}
                height={'60px'}
                alt="icon"
                style={{marginRight: "5px"}}
              />
            </ListItemAvatar>
            <ListItemText 
              sx={{
                whiteSpace: { xs: 'wrap', lg: 'nowrap' },
                maxWidth: { xs: '100px' }
              }}
              primary={item?.item} 
            />
          </ListItem>
          <Divider sx={{bgcolor: "purple"}} />
        </React.Fragment>
      );
    })) : (
        <Typography
          variant="subtitle1"
          color={'GrayText'}
          sx={{ fontSize: '14px', padding: '30px 40%' }}
        >
          No Items to show
        </Typography>
    )}
    </List>
  )
}